export interface SearchablePage {
  title: string;
  path: string;
  keywords: string[];
}

export const searchablePages: SearchablePage[] = [
  // Core Main Pages
  {
    title: "Home",
    path: "/",
    keywords: [
      "home",
      "main",
      "alexander rodriguez",
      "alex rodriguez",
      "alexrodriguez",
      "counsellor",
      "life coach",
    ],
  },
  {
    title: "About Me",
    path: "/about",
    keywords: [
      "about",
      "bio",
      "experience",
      "credentials",
      "story",
      "alexander rodriguez",
      "profile",
    ],
  },
  {
    title: "Book a Session",
    path: "/booking",
    keywords: [
      "booking",
      "book",
      "appointment",
      "schedule",
      "calendar",
      "consultation",
      "session",
      "fees",
    ],
  },
  {
    title: "Contact",
    path: "/contact",
    keywords: [
      "contact",
      "email",
      "phone",
      "location",
      "address",
      "support",
      "reach out",
      "message",
    ],
  },
  {
    title: "Frequently Asked Questions",
    path: "/counselling-faq",
    keywords: [
      "faq",
      "frequently asked questions",
      "help",
      "questions",
      "info",
      "what to expect",
      "pricing",
    ],
  },
  {
    title: "Our Team",
    path: "/teams",
    keywords: [
      "team",
      "staff",
      "practitioners",
      "counsellors",
      "therapists",
      "meet the team",
    ],
  },

  // Counselling Hub & Services
  {
    title: "Counselling Services",
    path: "/counselling",
    keywords: [
      "counselling",
      "therapy",
      "mental health",
      "therapist",
      "support",
      "counseling",
      "sessions",
    ],
  },
  {
    title: "Anger Management",
    path: "/anger-management",
    keywords: [
      "anger management",
      "rage",
      "frustration",
      "temper",
      "calm",
      "emotional regulation",
      "outbursts",
    ],
  },
  {
    title: "Career Counselling",
    path: "/career-counselling",
    keywords: [
      "career counselling",
      "job",
      "work",
      "profession",
      "career change",
      "interview",
      "resume",
      "employment",
    ],
  },
  {
    title: "Depression & Anxiety",
    path: "/depression-anxiety",
    keywords: [
      "depression",
      "anxiety",
      "panic attacks",
      "stress",
      "worry",
      "sadness",
      "mental health",
      "overwhelm",
    ],
  },
  {
    title: "Grief & Loss",
    path: "/grief-loss",
    keywords: [
      "grief",
      "loss",
      "bereavement",
      "mourning",
      "death",
      "heartbreak",
      "healing",
      "sadness",
    ],
  },
  {
    title: "Relationship Counselling",
    path: "/relationships",
    keywords: [
      "relationships",
      "couples",
      "marriage",
      "family",
      "communication",
      "breakup",
      "divorce",
      "boundaries",
    ],
  },

  // Life Coach Hub & Services
  {
    title: "Life Coaching",
    path: "/life-coach",
    keywords: [
      "life coach",
      "coaching",
      "goals",
      "motivation",
      "personal development",
      "growth",
      "mentor",
    ],
  },
  {
    title: "Changing Habits",
    path: "/changing-habits",
    keywords: [
      "changing habits",
      "break bad habits",
      "routine",
      "behavior",
      "discipline",
      "lifestyle",
      "addiction",
    ],
  },
  {
    title: "Focus & Productivity",
    path: "/focus-productivity",
    keywords: [
      "focus",
      "productivity",
      "procrastination",
      "efficiency",
      "deep work",
      "motivation",
      "distraction",
    ],
  },
  {
    title: "Public Speaking",
    path: "/public-speaking",
    keywords: [
      "public speaking",
      "presentation",
      "confidence",
      "stage fright",
      "speech",
      "communication",
      "talking",
    ],
  },
  {
    title: "Self-Esteem & Confidence",
    path: "/self-esteem-confidence",
    keywords: [
      "self-esteem",
      "confidence",
      "self-worth",
      "imposter syndrome",
      "insecurity",
      "empowerment",
    ],
  },
  {
    title: "Time Management",
    path: "/time-management",
    keywords: [
      "time management",
      "schedule",
      "planning",
      "organization",
      "busy",
      "priorities",
      "overwhelm",
    ],
  },

  // Allied Health Hub & Services
  {
    title: "Allied Health Services",
    path: "/allied-health",
    keywords: [
      "allied health",
      "holistic",
      "healthcare",
      "therapy team",
      "clinical",
      "support services",
    ],
  },
  {
    title: "Occupational Therapy",
    path: "/occupational-therapy",
    keywords: [
      "occupational therapy",
      "ot",
      "rehabilitation",
      "daily living",
      "skills",
      "functional assessment",
    ],
  },
  {
    title: "Psychology",
    path: "/psychology",
    keywords: [
      "psychology",
      "psychologist",
      "clinical psychology",
      "assessment",
      "mental health treatment",
    ],
  },

  // Resources
  {
    title: "Blogs",
    path: "/wellness-blog",
    keywords: [
      "Wellness Blog",
      "articles",
      "reading",
      "mental health tips",
      "insights",
      "blogs",
      "resources",
      "posts",
    ],
  },
  {
    title: "Podcasts",
    path: "/podcast",
    keywords: [
      "counselling podcast",
      "audio",
      "listen",
      "episodes",
      "interviews",
      "shows",
      "media",
    ],
  },
  {
    title: "Mini Games",
    path: "/mini-games",
    keywords: [
      "mini games",
      "games",
      "game",
      "play",
      "interactive",
      "quiz",
      "personality test",
      "iq test",
      "emotions",
      "self discovery",
      "itch.io",
    ],
  },

  // Programs & Courses
  {
    title: "24/7 Course Discovery",
    path: "/24seven-self-discovery",
    keywords: [
      "24seven",
      "self-discovery",
      "online course",
      "program",
      "self-guided",
      "workshop",
      "training",
    ],
  },

  // Legal Pages
  {
    title: "Privacy Policy",
    path: "/privacy-policy",
    keywords: [
      "privacy policy",
      "legal",
      "data protection",
      "terms",
      "gdpr",
      "privacy",
    ],
  },
  {
    title: "Terms of Use",
    path: "/terms-of-use",
    keywords: [
      "terms of use",
      "terms and conditions",
      "legal",
      "disclaimer",
      "agreement",
    ],
  },
];
